module.exports = __webpack_public_path__ + "img/Xywztzze.4ada2c4c.svg";